import Const from 'constants';
import {LpClassic as BaseLP} from 'services/sports/mlb/lp/lp-classic';
import {preparePlayerUID} from 'helpers/player-helper';

export default class LpClassic extends BaseLP {
    subjectToPermanent() {
        const constraints = {
            players: this.exec('prepareSectionByPlayer', {}, ''),
            salary: this.exec('prepareSectionBySalary', {}, ''),
            projectedOwnershipCap: this.exec(
                'projectedOwnership',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            projectedOwnershipForce: this.exec(
                'forceOfProjectedOwnership',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            positions: this.exec('prepareSectionByPosition', {}, ''),
            // teams: this.exec('prepareSectionByTeam', {}, ''),
            teams: this.exec('team', {}, ''),
            limitPositions: this.exec('limitPositions', {}, ''),
            games: this.exec('prepareSectionByGame', {addPositionToPID: true}, ''),
            projectionBoostRule: this.exec(
                'projectionBoostRule',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            limitOnePitcherPerGame: this.exec(
                'limitOnePitcherPerGame',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            playersWhoseGamesAreLocked: this.exec(
                'playersWhoseGamesAreLocked',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            createdLineups: this.exec('prepareSectionByCreatedLineups', {}, ''),
            multiPositions: this.exec('prepareSectionByMultiPositions', {}, ''),
            hitterStacks: this.exec('prepareSectionByHittersStack', {}, ''),
            nonControlledHittersStacking: this.exec(
                'nonControlledHittersStacking',
                {
                    getUnitIdsByPlayer: (player) => preparePlayerUID(player),
                },
                '',
            ),
            exposureMax: this.exec('prepareSectionByExposureMax', {}, ''),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            teamExposureMax: this.exec(
                'teamExposureMax',
                {
                    minPlayersQuantityToIdentifyUsedTeam: Const.MLB_MIN_PLAYERS_QUANTITY_TO_IDENTIFY_USED_TEAM,
                },
                '',
            ),
            playerCombinationStacking: this.exec(
                'playerCombinationStacking',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
        };

        return {...constraints};
    }
}
